import React from "react";
import PropTypes from "prop-types";
import styles from "./sectionToggle.module.css";
import LoadingAnimation from "../loadingAnimation/loadingAnimation";

export default class SectionToggle extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      checked: true,
      height: this.props.autoHeight ? "auto" : this.props.height || 550,
      minHeight: 500,
      paddingBottom: this.props.paddingBottom || 0
    };
    this.contentRef = React.createRef();
    this.baseHeight = 0;
    this.maxHeight = this.props.maxHeight || 5000;
  }

  componentDidMount() {
    if (this.props.autoHeight) {
      this.setState({ height: "none" });
    }
  }

  componentDidUpdate() {
    if (this.props.autoHeight || this.props.isLoading) {
      return;
    }

    if (
      this.contentRef.current.offsetHeight > 0 &&
      this.baseHeight !== this.contentRef.current.offsetHeight
    ) {
      this.baseHeight = Math.max(
        this.baseHeight,
        this.contentRef.current.offsetHeight,
        this.state.height
      );

      if (this.state.height < this.baseHeight) {
        this.setState({ height: this.baseHeight });
      }
    }
  }

  handleChange = () => {
    let checked = !this.state.checked;

    this.props.sectionToggled && this.props.sectionToggled(checked);

    this.setState({
      checked
    });
  };

  render() {
    const contentInnerClasses = [styles.sectionContentInner, "section-content-inner"].join(" ");

    return (
      <div
        data-testid={this.props.title}
        className={"react-section-wrapper " + this.props.customClass}
      >
        <div className="section-inner">
          <div className="react-section-title">
            <span className="text" data-testid="title">
              {this.props.title}
              {this.props.showCta ? (
                <a className="cta" href={this.props.ctaLink} data-testid="cta">
                  {this.props.ctaContent}
                </a>
              ) : null}
            </span>
            <div className="learn" data-testid="learn-more">
              {this.props.learnMore}
            </div>

            {!this.props.hideToggle ? (
              <div className="sectionToggle" onClick={this.handleChange} data-testid="toggle">
                <svg
                  width="12"
                  height="7"
                  viewBox="0 0 12 7"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className={`angleIcon ${this.state.checked ? "" : "angleIcon--flipped"}`}
                >
                  <path
                    d="M1 6.00002L6.00002 1L11 6.00002"
                    stroke="white"
                    strokeWidth="1.66667"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
            ) : null}
          </div>
          <div
            className="section-content"
            style={{
              maxHeight: this.maxHeight,
              minHeight: this.state.height,
              paddingBottom: this.props.paddingBottom,
              display: this.state.checked ? " flex" : "none"
            }}
            data-testid="content-container"
          >
            <div
              className={contentInnerClasses}
              ref={this.contentRef}
              style={{ maxHeight: this.maxHeight, minHeight: this.state.height }}
              data-testid="content"
            >
              {this.props.isLoading ? (
                <LoadingAnimation
                  height={this.props.autoHeight ? this.state.minHeight : this.state.height}
                />
              ) : (
                this.props.content
              )}
              <div className="clear-fix" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

SectionToggle.propTypes = {
  title: PropTypes.string,
  content: PropTypes.any,
  customClass: PropTypes.string,
  showCta: PropTypes.bool,
  ctaLink: PropTypes.string,
  ctaContent: PropTypes.string,
  sectionToggled: PropTypes.func,
  hideToggle: PropTypes.bool,
  learnMore: PropTypes.any,
  autoHeight: PropTypes.bool,
  isLoading: PropTypes.bool,
  height: PropTypes.number,
  maxHeight: PropTypes.any,
  paddingBottom: PropTypes.number
};

SectionToggle.defaultProps = {
  customClass: ""
};
